import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DEFAULT_LANGUAGE, InternationalizationService, SupportedLanguage } from '@examdojo/core/i18n';

const LANGUAGE_SETTING_STORAGE_KEY = 'user_language';

@Injectable({ providedIn: 'root' })
export class LanguageService extends InternationalizationService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  override setActiveLang(lang: SupportedLanguage) {
    super.setActiveLang(lang);
    if (this.isBrowser) {
      localStorage.setItem(LANGUAGE_SETTING_STORAGE_KEY, lang);
    }
  }

  loadLanguageFromLocalStorage() {
    const lang = this.isBrowser
      ? ((localStorage.getItem(LANGUAGE_SETTING_STORAGE_KEY) as SupportedLanguage | null) ?? DEFAULT_LANGUAGE)
      : DEFAULT_LANGUAGE;
    super.setActiveLang(lang);
  }
}
